<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="커뮤니티" src="/images/sub/subvisual-community.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last">
            <template #title>IR</template>

            <table class="board-view">
                <tr>
                    <th colspan="2">{{board.subject}}</th>
                </tr>
                <tr>
                    <td colspan="2">
                        <v-row class="row--sm">
                            <v-col cols="auto">
                                <span>작성일 : {{$dayjs(board.createdAt).format("YYYY-MM-DD HH:mm:ss")}}</span>
                            </v-col>
                        </v-row>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <v-row class="row--sm">
                            <v-col cols="auto">
                                <div class="d-flex">
                                    <div class="pr-6px pr-md-10px"><icon-down class="primary--text" /></div>
                                    <span @click="download(board?.files[0]?.url)">첨부파일 : {{board?.files[0]?.fileName}}</span>
                                </div>
                            </v-col>
                        </v-row>
                    </td>
                </tr>
                <tr>
                <tr>
                    <td colspan="2" class="content_box">
                        <div v-html="board.content"></div>
                    </td>
                </tr>
            </table>

            <div class="pt-16px pt-md-24px">
                <v-row justify="end" class="row--xs">
                    <v-col cols="auto">
                        <v-btn @click="$router.go(-1)" tile outlined color="grey" style="border-radius:10px 0 10px 0;">리스트</v-btn>
                    </v-col>
                </v-row>
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import download from "downloadjs";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import IconDown from "@/components/client/icons/icon-down.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        IconDown,
    },
    props: {},
    data() {
        return {
            board: {
                subject: null,
                content: null,
                files: [],
                createdAt: null,
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { board } = await api.v1.boards.get({ _id: this.$route.params._id });
            this.board = board;
        },
        download
    },
};
</script>

<style lang="scss" scoped></style>
